module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("settings")]), _vm._v(" " + _vm._s(_vm.$t('parametro.preferencias')))], 1), _vm._v(" "), _c('v-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "primary tab-preferencias",
    attrs: {
      "dark": ""
    }
  }, [(_vm.$store.state.permissions['parametros:read']) ? _c('v-tabs-item', {
    key: "parametros",
    attrs: {
      "href": "#parametros",
      "ripple": ""
    }
  }, [_c('v-icon', [_vm._v("settings_applications")]), _vm._v(" " + _vm._s(_vm.$t('parametro.title')) + "\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['roles:read']) ? _c('v-tabs-item', {
    key: "roles",
    attrs: {
      "href": "#roles",
      "ripple": ""
    }
  }, [_c('v-icon', [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('rol.title')) + "\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "warning"
    }
  })], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "parametros",
    attrs: {
      "id": "parametros"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.$store.state.permissions['parametros:read'] && _vm.active == 'parametros') ? _c('parametro') : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "roles",
    attrs: {
      "id": "roles"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.$store.state.permissions['roles:read'] && _vm.active == 'roles') ? _c('rol') : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d20a8e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/preferencias/Preferencias.vue
// module id = 527
// module chunks = 2